/**
 * @license
 * Copyright 2017 JBoss Inc
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, Input} from "@angular/core";
import {NgModel} from "@angular/forms";


@Component({
    selector: "form-error-message",
    templateUrl: "form-error-message.component.html"
})
export class FormErrorMessageComponent {

    @Input() inputModel: NgModel;
    @Input() type: string;
    @Input() alwaysOn: boolean;

    public isError(): boolean {
        return this.inputModel.invalid && (this.inputModel.dirty || this.inputModel.touched) && this.inputModel.errors[this.type];
    }

    public isVisible(): boolean {
        return this.alwaysOn || this.isError();
    }
}
